var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-down"},[_c('a-button',{attrs:{"type":"link","disabled":(!!_vm.timer)||_vm.disabled},nativeOn:{"click":function($event){return _vm.countDown($event)}}},[_vm._v(_vm._s(_vm.timer ?_vm.countNum+'秒': _vm.msg))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }